// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"wg8aM","congratulationsText":"_22Zq_","downloadsReceiptText":"_1JnYF","kavachBannerWrapper":"_2a9zd"};